export default __webpack_public_path__ + "static/0123-7502009c44d91fe92d44510840875b90.png";